var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "gameChart" }, [
    _c("span", { staticClass: "fs-xl text mx-2" }, [_vm._v("游戏充值排行榜")]),
    _c(
      "div",
      { attrs: { id: "ranking-board" } },
      [
        _vm.clientHeight
          ? _c("dv-scroll-ranking-board", {
              style: { height: _vm.clientHeight + "px" },
              attrs: { config: _vm.config }
            })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }